import styled from "styled-components";
import { Color } from "../../../../../../themes/definitions/casino777/casino777-colors";
import { hexToRgba } from "../../../../../../themes/hex-to-rgba";
import { LiveCasinoArenaNavbarButtonDefaultBox } from "./live-casino-arena-navbar-button.default.box";

export const LiveCasinoArenaNavbarButtonCasino777Box = styled(LiveCasinoArenaNavbarButtonDefaultBox)`

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        &:first-child {
            border-left: none;
            border-right: 1px solid ${({theme}) => hexToRgba(theme.colors.brandPrimary, 0.6)};
        }
        &:last-child {
            border-left: 1px solid ${hexToRgba(Color.tan, 0.6)};
            border-right: none;
        }

        border-left: 1px solid ${hexToRgba(Color.tan, 0.6)};
        border-right: 1px solid ${({theme}) => hexToRgba(theme.colors.brandPrimary, 0.6)};
    }
`;
